import { Link } from 'react-router-dom'
import { Container, FilledButton } from '@sainsburys-tech/luna-react'
import ErrorIcon from '../../../assets/ErrorIcon'

const FailingMessage = () => {
  return (
    <div>
      <Container size="xs">
        <div className="generic-container">
          <ErrorIcon />
          <div className="ln-u-text-align-left margin-top-small generic-inner-container ln-u-padding-sides*2 ln-u-padding-bottom*4">
            <p>
              There is a problem in creating workOrder due to Concurrency request. Please try after some time. 
            </p>
          </div>
          <Link to="/fmassist_landing">
            <FilledButton className="generic-home-button">Home</FilledButton>
          </Link>
        </div>
      </Container>
    </div>
  )
}

export default FailingMessage
